export default "__VITE_ASSET__2223b38a__"